import { library } from "@fortawesome/fontawesome-svg-core";
import Clarity from "@microsoft/clarity";
import { ThemeProvider } from "@mui/material";
import React, { useEffect } from "react";
import ReactGA from "react-ga";
import { BrowserRouter } from "react-router-dom";

import { environment } from "~/environment";
import { useAuthStorageEffect } from "~/utils";

import { icons } from "./icons";
import { CookiesConsent } from "./ui/components/cookiesConsent";
import { Notification } from "./ui/components/notification";
import { ScrollToTop } from "./ui/components/scrollToTop";
import {
  ChatContextProvider,
  NotificationsSettingsContextProvider,
} from "./ui/context";
import Layout from "./ui/layout";
import Routes from "./ui/routes";
import { appTheme } from "./ui/theme";

ReactGA.initialize(environment.GA4_MEASURE_ID);
if (environment.CLARITY_PROJECT_ID) {
  Clarity.init(environment.CLARITY_PROJECT_ID);
}
library.add(...icons);

export const App: React.FC = () => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  useAuthStorageEffect();
  return (
    <ThemeProvider theme={appTheme}>
      <BrowserRouter>
        <ScrollToTop />
        <CookiesConsent />
        <ChatContextProvider>
          <NotificationsSettingsContextProvider>
            <Notification>
              <Layout>
                <Routes />
              </Layout>
            </Notification>
          </NotificationsSettingsContextProvider>
        </ChatContextProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
};
